export enum defaultBrandingColors {
  backgroundColor = '#33447c',
  primaryColor = '#f4d138',
  secondaryColor = '#46978c',
  tertiaryColor = '#286496',
  highlightColor = '#029cef',
  headlineColor = '#ffffff',
  primaryCtaColor = '#33447c',
  secondaryCtaColor = '#ffffff',
}
